import styled, { css } from "styled-components";
import { Device } from "@pepdirect/v3/styles/screenSizes";
import { colors } from "@pepdirect/v3/styles/variables";

// Outer and inner content are required so that the
// columns flex properly at all laptop screen sizes
export const StyledOuterContent = styled.div`
  display: flex;
  justify-content: center;
`;

export const StyledInnerContent = styled.div`
  width: 100%;

  @media ${Device.laptop} {
    max-width: 1030px;
    margin: 30px 30px 30px;
  }
`;

export const StyledCheckoutMainContent = styled.div`
  @media ${Device.laptop} {
    display: flex;
    gap: 30px;
  }
`;

export const column = css`
  background-color: white;
  padding: 20px;
  border-radius: 6px;
`;

export const StyledCheckoutLeftColumn = styled.div<{ showBorder?: boolean }>`
  ${column};
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 20px;

  @media ${Device.laptop} {
    padding: 20px 40px 40px;
  }

  ${({ showBorder }) =>
    showBorder &&
    `
    border: 1px solid ${colors.gray200};
  `}
`;
